import { DOCUMENT_STATE_NORMAL } from '@/common/page_comp/Documents/document.states.js';
import { save, updateInfo } from '@/restapi/document/document.js';


export default class {
    id = null;
    value = {
        name: '',
        size: 0,
        type: null,
        accessType: 'PUBLIC',
        created: null,
    };
    state = DOCUMENT_STATE_NORMAL;
    loading = false;
    loadingError = false;
    removed = false;
    checked = false;
    edited = false;

    canRemove = false;
    canRestore = false;
    canEdit = false;
    canSelect = false;

    file = null;

    constructor(file) {
        const isFileType = file instanceof File;

        this.id = file.id;
        this.value = {
            id: file.id,
            name: file.name,
            size: file.size,
            type: !isFileType ? (file.type?.id ?? file.type) : null,
            accessType: file.accessType,
            created: file.created,
        };

        if (isFileType)
            this.file = file;
    }

    #canUpload() {
        return this.loading === false && this.id == null && this.file != null;
    }

    #canUpdate() {
        return this.loading === false && this.id != null;
    }

    async upload() {
        if (!this.#canUpload())
            return;

        try {
            this.loading = true;
            this.id = this.value.id = await save(this.file);
        } catch (e) {
            this.loadingError = true;
            throw e;
        } finally {
            this.loading = false;
        }
    }

    async updateInfo() {
        if (!this.#canUpdate())
            return;

        try {
            this.loading = true;
            await updateInfo({
                id: this.id,
                name: this.value.name,
                size: this.value.size,
                type: this.value.type,
            });
        } catch (e) {
            this.loadingError = true;
            throw e;
        } finally {
            this.loading = false;
        }
    }
}
